import React from 'react';
import { X, Package } from 'lucide-react';
import { ProjectTemplate } from '../../lib/db';

interface ProjectTemplateSelectModalProps {
  isOpen: boolean;
  onClose: () => void;
  templates: ProjectTemplate[];
  onSelect: (template: ProjectTemplate) => void;
}

export function ProjectTemplateSelectModal({
  isOpen,
  onClose,
  templates,
  onSelect,
}: ProjectTemplateSelectModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-hidden">
      <div className="absolute inset-0 bg-gray-500 bg-opacity-75" onClick={onClose} />
      
      <div className="absolute inset-x-4 top-1/2 -translate-y-1/2 max-w-2xl mx-auto bg-white rounded-lg shadow-xl max-h-[80vh] overflow-hidden flex flex-col">
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-gray-900">Select Project Template</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500 transition-colors"
            >
              <X className="h-6 w-6" />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          {templates.length === 0 ? (
            <p className="text-center text-gray-500 py-8">
              No project templates available. Create templates from the Templates page.
            </p>
          ) : (
            <div className="grid gap-4">
              {templates.map(template => (
                <button
                  key={template.id}
                  onClick={() => onSelect(template)}
                  className="p-4 bg-white border border-gray-200 rounded-lg hover:shadow-md transition-shadow text-left w-full"
                >
                  <div className="flex items-start gap-3">
                    <Package className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <div className="flex-1">
                      <h3 className="font-semibold text-gray-900">{template.title}</h3>
                      {template.description && (
                        <p className="text-sm text-gray-600 mt-1">{template.description}</p>
                      )}
                      <span className="text-xs text-gray-500 mt-2 inline-block">
                        {template.is_system ? 'System Template' : 'Custom Template'}
                      </span>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}